export default __webpack_public_path__ + "static/plp--bundle--blanco-e30ba566b928bbe8b97c71809dcadae7.png";